import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { formatErr } from "../lib/api";
import { Crown } from "lucide-react";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await login(form.email, form.password);
            toast.success(`Welcome back, ${u.name}`);
            navigate(u.role === "admin" ? "/admin" : "/dashboard");
        } catch (err) {
            toast.error(formatErr(err));
        } finally { setLoading(false); }
    };

    const googleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div data-testid="login-page" className="min-h-[80vh] grid place-items-center px-5 py-16 grain">
            <div className="w-full max-w-md card-flat p-8">
                <Crown className="text-gold" size={28} />
                <h1 className="h-display text-4xl mt-4">Sign In</h1>
                <p className="text-ink text-sm mt-2">Welcome back to the kingdom.</p>

                <form onSubmit={submit} className="space-y-4 mt-7">
                    <div>
                        <label className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Email</label>
                        <input data-testid="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full mt-2 px-4 py-3 text-sm" />
                    </div>
                    <div>
                        <label className="text-[10px] tracking-[0.3em] uppercase text-ink font-bold">Password</label>
                        <input data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full mt-2 px-4 py-3 text-sm" />
                    </div>
                    <button type="submit" disabled={loading} data-testid="login-submit" className="btn-gold w-full py-4 text-xs disabled:opacity-60">
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>

                <div className="flex items-center gap-3 my-5">
                    <div className="h-px flex-1 bg-line" /><span className="text-[10px] tracking-[0.3em] uppercase text-ink">or</span><div className="h-px flex-1 bg-line" />
                </div>

                <button onClick={googleLogin} data-testid="login-google" className="btn-ghost-gold w-full py-4 text-xs">
                    Continue with Google
                </button>

                <div className="text-center mt-6 text-sm text-ink">
                    No account? <Link to="/register" className="text-gold hover:text-gold-bright" data-testid="login-register-link">Join the Kingdom</Link>
                </div>
            </div>
        </div>
    );
}
